import { render, staticRenderFns } from "./LongtermReport.vue?vue&type=template&id=2248bcbe"
import script from "./LongtermReport.vue?vue&type=script&lang=js"
export * from "./LongtermReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports